import request from '@/utils/request';
import Resource from '@/api/resource';
class ConvertResource extends Resource {
  constructor() {
    super('tool/convert/jrtt');
  }

  // 获取转化
  getApi(data) {
    return request({
      url: `/${this.uri}`,
      method: 'GET',
      params: data,
    });
  }

  // 同步转化
  pullConvertApi(data) {
    return request({
      url: `/${this.uri}/pull`,
      method: 'GET',
      params: data,
    });
  }

  // 创建转化
  creatApi(data) {
    return request({
      url: `/${this.uri}`,
      method: 'POST',
      data,
    });
  }

  // 编辑转化
  editStatusApi(data) {
    return request({
      url: `/${this.uri}/updateOptStatus`,
      method: 'POST',
      data,
    });
  }

  // 批量新增转化
  bacthAddConvert(data){
    return request({
      url: `/${this.uri}/batchAdd`,
      method: 'POST',
      data,
    });
  }
}
export { ConvertResource as default };
